import React from 'react';
import styled from 'styled-components';
import {ExecutionType} from '../../../../util/uiconstants';
import {currentResource} from '../../../../util/utils';

const AccountExecutionType = ({executionTypeId}) => {
	const renderExecutionTypes = () => {
		if (executionTypeId && executionTypeId !== ExecutionType.ExecutedInEngagement) {
			return (
				<StyledAccountExecutionTypeLabel
					className="StyledAccountExecutionTypeLabel executionTypeLabel"
					title={currentResource.executionType.find((et) => et.id === executionTypeId)?.toolTip}
				>
					<span className="executionTypeText">
						{currentResource.executionType.find((et) => et.id === executionTypeId)?.label}
					</span>
				</StyledAccountExecutionTypeLabel>
			);
		}
	};

	return <>{renderExecutionTypes()}</>;
};

export default AccountExecutionType;

const StyledAccountExecutionTypeLabel = styled.section`
	&.executionTypeLabel {
		margin-left: var(--px-16);
		border: var(--px-1) solid var(--neutrals-900);
		border-radius: var(--px-12);
		padding: var(--px-10);
		height: var(--px-24);
		display: inline-flex;
		align-items: center;
		width: auto;
		max-width: var(--px-200);
		.executionTypeText {
			font-size: var(--px-12);
			font-weight: 400;
			line-height: var(--px-16);
			color: var(--neutrals-900);
		}
	}
`;
